import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import "./RDDDAlternatePayment.css";
import { toast } from "react-toastify";

const RDDDAlternatePayment = () => {
  const { profile } = useSelector((state) => state.userProfile);
  const { id } = useParams();
  const navigate = useNavigate();
  const accountId = id;
  const location = useLocation();

  const currentAccountData = location.state?.account;

  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);

  const [totalDeposited, setTotalDeposited] = useState(
    Number(currentAccountData?.totalDeposited || 0)
  );

  const [collectionDate, setCollectionDate] = useState("");
  const [collectionMode, setCollectionMode] = useState("Cash");
  const [amount, setAmount] = useState("");
  const [remarks, setRemarks] = useState("");
  const [payLoading, setPayLoading] = useState(false);


  const fetchData = async () => {
    try {
      const res = await axios.get(
        `https://payyug.in/api/deposit/dd-collection/${accountId}?type=${currentAccountData?.accountType}`
      );
      if (res.data?.success && Array.isArray(res.data.data)) {
        setAccount(res.data.data);
        
        if (res.data.data.length > 0 && res.data.data[0]?.account) {
          const liveTotal = Number(res.data.data[0].account.totalDeposited || 0);
          setTotalDeposited(liveTotal);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message||"Failed to load Payments");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [accountId, currentAccountData]);

  useEffect(() => {
    if (currentAccountData?.totalDeposited) {
      setTotalDeposited(Number(currentAccountData.totalDeposited));
    }
  }, [currentAccountData]);

  if (loading) {
    return (
      <div className="rd-alt-pay-loading-box">
        <div className="rd-alt-pay-spinner"></div>
        <p>Loading account schedule details...</p>
      </div>
    );
  }

  const parsedAccountData = account && account.length > 0 ? account[0].account : currentAccountData;

  if (!account) {
    return (
      <div className="rd-alt-pay-error-box">
        <p>No account records found for this ID.</p>
        <button className="rd-alt-pay-btn secondary" onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  return (
    <div className="rd-alt-pay-wrapper">
      {/* HEADER SECTION */}
      <div className="rd-alt-pay-header-section">
        <div>
          <h2 className="rd-alt-pay-title">{parsedAccountData?.accountType || "Deposit"} Alternative Payment</h2>
        </div>
        <button className="rd-alt-pay-btn primary large" onClick={() => setShowDialog(true)}>
          <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" /></svg>
          Alternate Pay
        </button>
      </div>

      {/* OVERVIEW CARDS */}
      <div className="rd-alt-pay-grid">
        <div className="rd-alt-pay-card">
          <span className="rd-alt-pay-card-label">Account Number</span>
          <span className="rd-alt-pay-card-value">{parsedAccountData?.accountNo || "—"}</span>
        </div>
        <div className="rd-alt-pay-card">
          <span className="rd-alt-pay-card-label">Account Type</span>
          <span className="rd-alt-pay-card-value-badge">{parsedAccountData?.accountType || "—"}</span>
        </div>
        <div className="rd-alt-pay-card">
          <span className="rd-alt-pay-card-label">Customer Name</span>
          <span className="rd-alt-pay-card-value">{parsedAccountData?.customerName || "—"}</span>
        </div>
        
        {/* Dynamic dynamic display (Real-time Updated) */}
        <div className="rd-alt-pay-card highlighted">
          <span className="rd-alt-pay-card-label">Total Deposited</span>
          <span className="rd-alt-pay-card-value">₹ {totalDeposited.toLocaleString("en-IN")}</span>
        </div>
      </div>

      {/* ADDITIONAL METRICS FROM RESPONSE */}
      <div className="rd-alt-pay-grid">
        <div className="rd-alt-pay-card">
          <span className="rd-alt-pay-card-label">Maturity Amount</span>
          <span className="rd-alt-pay-card-value">₹ {parsedAccountData?.maturityAmount?.toLocaleString("en-IN") || 0}</span>
        </div>
        <div className="rd-alt-pay-card">
          <span className="rd-alt-pay-card-label">Scheme Name</span>
          <span className="rd-alt-pay-card-value" style={{fontSize: "14px"}}>{parsedAccountData?.schemeName || "—"}</span>
        </div>
      </div>

      {/* SCHEDULE TABLE */}
      <div className="rd-alt-pay-table-wrapper">
        <table className="rd-alt-pay-table">
          <thead>
            <tr>
              <th style={{ width: "80px" }}>S.No</th>
              <th>Paid Date</th>
              <th>Amount</th>
              <th>Receipt No</th>
              <th>Status</th>
              <th style={{ textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(account) && account.length > 0 ? (
              account.map((payment, index) => {
                const isPaid = payment?.status?.toLowerCase() === "paid";
                return (
                  <tr key={payment?.id || index} className={isPaid ? "status-paid-row" : "status-pending-row"}>
                    <td><strong>{index + 1}</strong></td>
                    <td>
                      {payment?.date ? new Date(payment.date).toLocaleDateString("en-GB") : "—"}
                    </td>
                    <td><span className="rd-alt-pay-table-amount">₹{payment?.amount ?? 0}</span></td>
                    <td><span style={{fontFamily: "monospace", fontSize:"12px"}}>{payment?.receiptNo || "—"}</span></td>
                    <td>
                      <span className={`rd-alt-pay-badge ${isPaid ? "paid" : "pending"}`}>
                        {payment?.status || "Pending"}
                      </span>
                    </td>
                    <td>
                      <div className="rd-alt-pay-action-group">
                        <button
                          className="rd-alt-pay-table-btn"
                          onClick={() =>
                            navigate("/Banking/DepositAccount/AlternatePaymentReceipt", {
                              state: { currentAccountData: parsedAccountData, payment },
                            })
                          }
                        >
                          <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                          Receipt
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6" className="rd-alt-pay-no-data">
                  No execution Payments found for this record.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* DIALOG / MODAL SUBMISSION */}
      {showDialog && (
        <div className="rd-alt-pay-modal-overlay">
          <div className="rd-alt-pay-modal-box">
            <div className="rd-alt-pay-modal-header">
              <h3>Alternative Payments</h3>
              <button className="rd-alt-pay-close-x" onClick={() => setShowDialog(false)}>&times;</button>
            </div>

            <div className="rd-alt-pay-modal-body">
              <div className="rd-alt-pay-form-group">
                <label>Collection Date</label>
                <input
                  type="date"
                  value={collectionDate}
                  onChange={(e) => setCollectionDate(e.target.value)}
                />
              </div>

              <div className="rd-alt-pay-form-group">
                <label>Collection Mode</label>
                <select value={collectionMode} onChange={(e) => setCollectionMode(e.target.value)}>
                  <option value="Cash">Cash</option>
                  <option value="UPI">UPI</option>
                  <option value="Bank">Bank</option>
                </select>
              </div>

              <div className="rd-alt-pay-form-group">
                <label>Amount (₹)</label>
                <input
                  type="number"
                  value={amount}
                  placeholder="Enter Amount"
                  onChange={(e) => setAmount(e.target.value)}
                />
              </div>

              <div className="rd-alt-pay-form-group">
                <label>Remarks</label>
                <input
                  type="text"
                  placeholder="Optional context note"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                />
              </div>
            </div>

            <div className="rd-alt-pay-modal-footer">
              <button className="rd-alt-pay-btn secondary" onClick={() => setShowDialog(false)} disabled={payLoading}>
                Cancel
              </button>
              <button
                className="rd-alt-pay-btn primary"
                disabled={payLoading}
                onClick={async () => {
                  if(!amount || !collectionDate) {
                    toast.error("Please fill all compulsory values");
                    return;
                  }
                  try {
                    setPayLoading(true);
                    const payload = {
                      superAdminId: Number(profile?.superAdminId),
                      branchId: Number(profile?.branchId),
                      accountId: Number(accountId),
                      amount: Number(amount),
                      collectionDate,
                      collectionMode,
                      type: parsedAccountData?.accountType,
                      collectedBy: Number(profile?.id || localStorage.getItem("userId") || 1),
                      remarks,
                      status: "Paid",
                    };

                    const res = await axios.post("https://payyug.in/api/deposit/pay-dd-alternative", payload);

                    if (res.data.success) {
                      toast.success(res?.data?.message || "Alternate Paid Successfully!");
                      setTotalDeposited((prev) => prev + Number(amount));

                      setShowDialog(false);
                      setAmount("");
                      setRemarks("");
                      setCollectionDate("");
                      fetchData();
                    } else {
                      toast.error(res.data.message || "Execution error encountered.");
                    }
                  } catch (err) {
                    toast.error("Network communication error.");
                  } finally {
                    setPayLoading(false);
                  }
                }}
              >
                {payLoading ? "Processing..." : "Confirm & Pay"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RDDDAlternatePayment;